export const blockIconsHouseholdCookingNew = (
	<span className='material-symbols-outlined'>cooking</span>
);
